export default __webpack_public_path__ + "static/media/gwn24.27dce919.webp";